// shared/helpers/documentos.js

import { Print, ReceiptLong, Assignment, RequestPage, Factory } from '@mui/icons-material';
import Receipt from '@mui/icons-material/Receipt';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';

import { DOCUMENTO_TIPOS, OPERACAO_SIGLAS } from '../constants';

export const getDocumentoIcon = (tipo) => {
    switch (tipo) {
        case DOCUMENTO_TIPOS.PEDIDO:
        case DOCUMENTO_TIPOS.REQUISICAO:
            return <Print />;
        case DOCUMENTO_TIPOS.CUPOM:
            return <Receipt />;
        case DOCUMENTO_TIPOS.CONTRATO:
            return <ReceiptLong />;
        case DOCUMENTO_TIPOS.GARANTIA:
            return <Assignment />;
        case DOCUMENTO_TIPOS.RECIBO:
            return <RequestPage />;
        case DOCUMENTO_TIPOS.INDUSTRIA:
            return <Factory />;
        case DOCUMENTO_TIPOS.TICKET:
            return <HistoryEduIcon />;
        default:
            return <Print />;
    }
};

export const filtrarDocumentos = ({ documentos, origem, sigla }) => {
    return documentos.filter((documento) => {
        const tipo = documento.Documento?.tipo;

        if (origem === OPERACAO_SIGLAS.REQ) {
            return tipo === DOCUMENTO_TIPOS.REQUISICAO;
        }

        if (sigla === OPERACAO_SIGLAS.CFR && tipo === DOCUMENTO_TIPOS.REQUISICAO) {
            return false;
        }

        return true;
    });
};
